(function()
{
  $(document).on("swell:setup", function() {
    Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    SwellConfig.Referral.authenticated();
    SwellConfig.Referral.populateReferrals();
    Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
    SwellConfig.Tier.initializeCustomTierProperties();
    SwellConfig.Tier.initializeTiers(".swell-tier-table");
    if($(".swell-post-checkout").length > 0)
    {
      $(".swell-post-checkout").css("display","flex");
    }
    $(".loader-holder").remove();
  });

  $(document).ready(function () {

    checkMyRewards();

    var next_tier = 2;
    reset();
    $(window).resize(function()
    {
      next_tier = 2;
      reset();
    });

    $('body').on('click','.table_arrow_right',function(e)
    {
      var tdclass = ".td";
      var tohide = tdclass + next_tier;
      if(next_tier < 4)
      {
        next_tier++;
        var nextToGo = tdclass + next_tier;
        $(tohide).css('display','none');
        $(nextToGo).css('display','table-cell');
        if(next_tier == 4)
        {
          $('.table_arrow_right').css('opacity','0.5');
        }
        else
        {
          $('.table_arrow_left').css('opacity','1');
        }
      }
      else
      {
        e.preventDefault();
      }
    });

    $('body').on('click','.table_arrow_left',function(e)
    {
      var tdclass = ".td";
      var tohide = tdclass + next_tier;
      if(next_tier > 2)
      {
        next_tier--;
        var previousToGo = tdclass + next_tier;
        $(tohide).css('display','none');
        $(previousToGo).css('display','table-cell');
        if(next_tier == 2)
        {
          $('.table_arrow_left').css('opacity','0.5');
        }
        else
        {
          $('.table_arrow_right').css('opacity','1');
        }
      }
      else
      {
        e.preventDefault();
      }
    });

    $('body').on('click','.close-post-popup',function()
    {
      $('.swell-post-checkout').remove();
    });
    
    $('body').on('click', '.swell-referral-copy', function(e){
      if($(e.target).hasClass("swell-referral-copy")) {
        e.stopPropagation();
      }
    });
    
    $('body').on('click','.goToCheckout',function(e)
    {
      window.location.href = '/checkout';
    });

    $('body').on('click', '.swell-share-referral-copy', function () {
      setTimeout(function () {
        if(window.location.href.indexOf("orders") > -1)
        {
          $('.swell-referral-copy .swell-referral-copy-content .swell-referral-copy-main .swell-referral-back-link').addClass("post-popup-copy-close");
        }
      }, 20);
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function() {
        $(".table-data").html("");
        SwellConfig.Referral.populateReferrals();
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-header-details").after('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }

      if(textStatus && textStatus === "Please enter a valid email address") {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-header-details").after('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });

  });
}).call(this);

//campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: ''
      }
    }
  };
}).call(this);

//refer
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "<span> Refer a Friend </span> Give $5, Get $5",
        referralRegisterFormDetails: "Enter your email to get started.",
        referralRegisterFormEmail: "Your Email Address",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $5 off on their first order of $40+ and get $5 for each successful referral.",

        referralReferHeading:"<span> Refer a Friend </span> Give $5, Get $5",
        referralReferFormEmails: "Your friends’ email (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends' emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $5 off on their first order of $40+ and get $5 for each successful referral.",

        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralFacebookIcon: "swell-icon-facebook-share",
        referralTwitterIcon: "swell-icon-twitter-brands",
        referralLinkIcon: "swell-icon-link",
        referralMessengerIcon: "swell-icon-message",
        referralSMSIcon: "swell-icon-sms",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p><div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralTwitterIcon %>" aria-hidden="true"></i> &nbsp;<%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareSMS%> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralMessengerIcon %>" aria-hidden="true"> </i> &nbsp;<%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    }, 
    authenticated: function () {
      if(spapi.authenticated)
      {
        if($(".redeem-holder").length > 0)
        {
          $(".redeem-holder").css('display','block');          
        }
      }
    },
    populateReferrals: function(){
      if (spapi.authenticated) {
        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function(referral_receipt) {
          var email = referral_receipt.email;
          var completed_at = referral_receipt.completed_at;
          if (completed_at) {
            status = "Purchased (" + spapi.activeReferralCampaign.reward_text + "earned)";
          } else {
            status = 'Invited';
          }
          $(".table-data").append("<tr class='swell-table-row'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
        });
      }
    }
  };

}).call(this);

//tiers
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var $tierStatusRow, $tierValueRow, col, columnLength, customer_tier_id, customer_tier_rank, data_id, dollar_difference, encouragement, index, k, l, next_tier, ref, ref1;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      if(customer_tier_id === null)
      {
        customer_tier_id = -1;
      }
      if(customer_tier_rank === null)
      {
        customer_tier_rank = 0;
      }
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      $(".swell-tier-table").addClass("swell-tier-status");
      $(".swell-tier-table thead").prepend("<tr class=\"swell-tier-status-row\">\n  <th scope=\"row\"></th>\n</tr>");
      $("[data-tier-id=\"" + customer_tier_id + "\"]").addClass("swell-tier-active");
      columnLength = $(".swell-tier-table tbody tr:eq(0)").children().length;
      $tierStatusRow = $(".swell-tier-status-row");
      $tierValueRow = $(".swell-tier-values");
      encouragement = "";
      dollar_difference = "";
      for (col = k = 1, ref = columnLength - 1; 1 <= ref ? k <= ref : k >= ref; col = 1 <= ref ? ++k : --k) {
        data_id = $(".swell-tier-table tbody tr:first td:eq(" + (col - 1) + ")").first().data("tierId");
        if (data_id === customer_tier_id) {
          for (index = l = 1, ref1 = col; 1 <= ref1 ? l <= ref1 : l >= ref1; index = 1 <= ref1 ? ++l : --l) {
            $tierValueRow.find("th:eq(" + index + ")").addClass("completed");
          }
        }
        if(spapi.customer.vip_tier)
        {
          if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
            encouragement = "<div class='current-encourage'><div>Current Status</div><p>You are in the top tier</p></div>";
          } else {
            encouragement = "<div class='current-encourage'><div>Current Status</div><p>Spend $"+Math.ceil((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100)+" or "+(next_tier.referrals_completed - swellAPI.getCustomerDetails().vipTierStats.referralsCompleted)+" referrals more to earn "+next_tier.name+"</p></div>";
          }
        }
        // else
        // {
        //   encouragement = "<div class='current-encourage-div'><p>Spend $"+(spapi.activeVipTiers[0].amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100+" more to earn "+spapi.activeVipTiers[0].name+"</p></div>";
        // }
      }
      var append_td_i;
      var tdclassno=2;
      var tdclass="td";
      var tdclass_append = tdclass + tdclassno;
      for ( append_td_i = customer_tier_rank; append_td_i > 0; append_td_i-- )
      {
        tdclass_append = tdclass + tdclassno;
        $tierStatusRow.append("<th scope='col' class='"+ tdclass_append +"'></th>");
        tdclassno++;
      }
      tdclass_append = tdclass + tdclassno;
      return $tierStatusRow.append("<th scope=\"col\" class='"+ tdclass_append +"'>" + encouragement + "</th>");
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[0].points = "Spend: $"+spapi.activeVipTiers[0].amount_spent_cents/100+"-$"+((spapi.activeVipTiers[1].amount_spent_cents/100))+" <br>or "+spapi.activeVipTiers[0].referrals_completed+" Referrals";
      spapi.activeVipTiers[0].one_point_multiplier = "1 X";
      spapi.activeVipTiers[0].welcome_offer = "<div class='circle'></div>";
      spapi.activeVipTiers[0].birthday = "<div class='circle'></div>";
      spapi.activeVipTiers[0].early_access = "";
      spapi.activeVipTiers[0].early_access_sales = "";
      spapi.activeVipTiers[0].free_shipping = "";
      spapi.activeVipTiers[0].annual_gift = "";

      spapi.activeVipTiers[1].points = "Spend: $"+spapi.activeVipTiers[1].amount_spent_cents/100+"-$"+((spapi.activeVipTiers[2].amount_spent_cents/100))+" <br>or "+spapi.activeVipTiers[1].referrals_completed+" Referrals";
      spapi.activeVipTiers[1].one_point_multiplier = "1.5 X";
      spapi.activeVipTiers[1].welcome_offer = "<div class='circle'></div>";
      spapi.activeVipTiers[1].birthday = "<div class='circle'></div>";
      spapi.activeVipTiers[1].early_access = "<div class='circle'></div>";
      spapi.activeVipTiers[1].early_access_sales = "<div class='circle'></div>";
      spapi.activeVipTiers[1].free_shipping = "";
      spapi.activeVipTiers[1].annual_gift = "";

      spapi.activeVipTiers[2].points = "Spend: $"+spapi.activeVipTiers[2].amount_spent_cents/100+"+ <br>or "+spapi.activeVipTiers[2].referrals_completed+" Referrals";
      spapi.activeVipTiers[2].one_point_multiplier = "2 X";
      spapi.activeVipTiers[2].welcome_offer = "<div class='circle'></div>";
      spapi.activeVipTiers[2].birthday = "<div class='circle'></div>";
      spapi.activeVipTiers[2].early_access = "<div class='circle'></div>";
      spapi.activeVipTiers[2].early_access_sales = "<div class='circle'></div>";
      spapi.activeVipTiers[2].free_shipping = "<div class='circle'></div>";
      spapi.activeVipTiers[2].annual_gift = "<div class='circle'></div>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          points: {
            className: "swell-tier-values",
            title: ""
          },
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          one_point_multiplier: {
            title: "Multiplier"
          },
          welcome_offer: {
            title: "Welcome offer"
          },
          birthday: {
            title: "Birthday offer"
          },
          early_access: {
            title: "Early access to <br class='mobile'>new products/flavors"
          },
          early_access_sales: {
            title: "Early access to sales"
          },
          free_shipping: {
            title: "Free shipping over <span>$50</span>"
          },
          annual_gift: {
            title: "Annual gift"
          },
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class=\"" + property.className + "\">\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope=\"col\" data-tier-id=\"" + tier.id + "\" class=\"" +tdclass_append+ "\">" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        var tdclassno=1;
        var tdclass="td";
        var tdclass_append=null;
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <td scope=\"row\">" + property.title + "</td>\n</tr>");
        tiers.forEach(function(tier) {
          tdclassno++;
          tdclass_append = tdclass + tdclassno;
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\" class=\"" +tdclass_append+ "\" >" + tier[key] + "</td>");
        });
        i++;
        reset();
      }
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };

}).call(this);

function reset()
{
  $('.table_arrow_left').css('opacity','0.5');
  check_window();
}

function check_window()
{
  if($(window).width() < 768 )
  {    
    $(".td2").css("display","table-cell"); 
    $(".td3").css("display","none"); 
    $(".td4").css("display","none");
  }
  else
  {
    $(".td2").css("display","table-cell");
    $(".td3").css("display","table-cell");
    $(".td4").css("display","table-cell");
  }
}

function checkMyRewards()
{
  if(window.location.href.indexOf("view=my-rewards") > -1)
  {
    $('body').addClass('my-rewards-account');
    if($(".breadcrumbs li:nth-child(2)").text())
    {
      $(".breadcrumbs li:nth-child(2)").text("Rewards");
    }
  }
}